import { render, staticRenderFns } from "./authorizerServices.vue?vue&type=template&id=15e0d13c&scoped=true&"
import script from "./authorizerServices.vue?vue&type=script&lang=js&"
export * from "./authorizerServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e0d13c",
  null
  
)

export default component.exports